"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var d3_1 = require("d3");
var escape_1 = require("../lib/escape");
var ITEM_SIZE = 20;
var Tooltip = /** @class */ (function () {
    function Tooltip(ctx) {
        var _this = this;
        /**
         * 排序箭头方向
         */
        this.arrow = "down";
        this.clearTimer = null;
        this.ctx = ctx;
        var classPrefix = this.ctx.classPrefix;
        this.overlay = d3_1.select("." + classPrefix + "-chart-overlay");
        if (this.overlay.empty()) {
            this.overlay = d3_1.select("body")
                .append("div")
                .attr("class", classPrefix + "-chart-overlay")
                .style("position", "absolute")
                .style("top", 0)
                .style("left", 0)
                .style("z-index", 1002);
        }
        else {
            this.overlay.selectAll("div").remove();
        }
        this.ctx.on("tooltip.scroll", function (eventData, allData, scrollTop) {
            _this.show(eventData, allData, scrollTop);
        });
    }
    Tooltip.prototype.selectGroup = function () {
        var _this = this;
        this.group = this.overlay.select("[data-id=\"" + this.ctx.id + "\"]");
        var _a = this.ctx.getOption("tooltip"), height = _a.height, maxHeight = _a.maxHeight, zIndex = _a.zIndex, width = _a.width;
        if (zIndex) {
            this.overlay.style("z-index", zIndex);
        }
        if (this.group.empty()) {
            this.group = this.overlay
                .append("div")
                .attr("class", this.ctx.classPrefix + "-chart-tooltip")
                .attr("data-id", this.ctx.id)
                .style("position", "fixed")
                .style("display", "block")
                .style("padding", "15px")
                .style("z-index", 99)
                .style("background", "#FFF")
                .style("white-space", "nowrap")
                .style("box-shadow", "0px 4px 8px 0px rgba(0, 0, 0, 0.15)")
                .style("transition", "visibility 0.6s cubic-bezier(0.23, 1, 0.32, 1) 0s, left 0.6s cubic-bezier(0.23, 1, 0.32, 1) 0s, top 0.6s cubic-bezier(0.23, 1, 0.32, 1) 0s");
            if (height) {
                this.group.style("overflow", "auto").style("height", height + "px");
            }
            if (maxHeight) {
                this.group.style("overflow", "auto").style("maxHeight", height + "px");
            }
            if (width) {
                this.group.style("width", width + "px");
            }
        }
        this.group.on("mouseleave touchend", function () {
            _this.ctx.emit("plot.mouse.left");
        });
    };
    /**
     * 数据排序
     * @param metaDatas legend展示的数据
     */
    Tooltip.prototype.sortData = function (metaDatas) {
        var data = [];
        if (metaDatas && Array.isArray(metaDatas)) {
            if (this.arrow === "up") {
                data = metaDatas.sort(function (a, b) {
                    return a.value > b.value ? 1 : -1;
                });
            }
            else {
                data = metaDatas.sort(function (a, b) {
                    return a.value < b.value ? 1 : -1;
                });
            }
        }
        return data;
    };
    Tooltip.prototype.show = function (eventData, allData, scrollTop) {
        var _this = this;
        if (scrollTop === void 0) { scrollTop = 0; }
        var index = eventData.index, x = eventData.x, y = eventData.y;
        var _a = this.ctx.getOption("tooltip"), formatter = _a.formatter, enableSort = _a.enableSort, _b = _a.header, header = _b === void 0 ? {} : _b, virtualizedScroll = _a.virtualizedScroll;
        var tmpMetaData = eventData.metaData.slice();
        var metaData = enableSort ? this.sortData(tmpMetaData) : tmpMetaData;
        if (metaData.length === 0)
            return;
        this.selectGroup();
        // 启用虚拟滚动时
        var indexRange = { start: undefined, end: undefined };
        if (virtualizedScroll) {
            this.group.on("scroll", function () {
                // eslint-disable-next-line no-restricted-globals
                var targetElement = d3_1.event && d3_1.event.target;
                _this.ctx.emit("tooltip.scroll", eventData, allData, targetElement.scrollTop);
            });
            indexRange = this.getVirtualListMetaData(metaData, scrollTop);
        }
        var _c = tslib_1.__read(metaData, 1), title = _c[0].title;
        var content = getTooltipContent(title, metaData, this.arrow, enableSort, header.typeText, header.valueText, indexRange);
        if (typeof formatter === "function") {
            var formatted = formatter(metaData, index, allData);
            if (typeof formatted === "string") {
                content = formatted;
            }
            else {
                var _d = tslib_1.__read(formatted, 1), title_1 = _d[0].title;
                content = getTooltipContent(title_1, formatted, this.arrow, enableSort, header.typeText, header.valueText);
            }
        }
        this.group.html(escape_1.escapeHTML(content));
        if (enableSort) {
            this.group.select("i").on("click", function () {
                _this.arrow = _this.arrow === "up" ? "down" : "up";
                _this.show(eventData, allData);
            });
        }
        var offset = 15;
        var _e = this.group.node().getBoundingClientRect(), width = _e.width, height = _e.height;
        var _f = this.ctx.root.node().getBoundingClientRect(), top = _f.top, left = _f.left;
        var plotWidth = parseInt(this.ctx.background.attr("width"), 10);
        var plotHeight = parseInt(this.ctx.background.attr("height"), 10);
        // 设置水平方向位置
        if (x + width > plotWidth) {
            this.group.style("left", x + left - offset - width + "px");
        }
        else {
            this.group.style("left", x + left + offset + "px");
        }
        // 设置垂直方向位置
        if (y + height > plotHeight) {
            this.group.style("top", y + top - height - offset + "px");
        }
        else {
            this.group.style("top", y + offset + top + "px");
        }
    };
    Tooltip.prototype.getVirtualListMetaData = function (metaData, scrollTop) {
        var _a = this.ctx.getOption("tooltip").height, height = _a === void 0 ? 200 : _a;
        var enableSort = this.ctx.getOption("tooltip").enableSort;
        // 虚拟滚动容器高度需减少tooltip头部标题部分高度，这部分是固定值
        var tooltipHeadHeight = !enableSort ? 46 : 83;
        var startIndex;
        if (scrollTop > tooltipHeadHeight) {
            startIndex = Math.floor((scrollTop - tooltipHeadHeight) / ITEM_SIZE);
        }
        else {
            startIndex = 0;
        }
        var endIndex = Math.floor((height + scrollTop - tooltipHeadHeight) / ITEM_SIZE);
        return { start: startIndex, end: endIndex };
    };
    Tooltip.prototype.hide = function () {
        var _this = this;
        // 确保 tooltip 一定会被销毁
        clearTimeout(this.clearTimer);
        this.clearTimer = setTimeout(function () {
            if (_this.group) {
                _this.group.remove();
            }
        }, 300);
    };
    return Tooltip;
}());
exports.Tooltip = Tooltip;
/**
 * 获取列表项样式
 * @param index 列表数据下标值
 * @param tooltipHeadHeight tooltip头部高度
 */
function getItemStyle(index, tooltipHeadHeight) {
    return "position: absolute; top: " + (tooltipHeadHeight + index * ITEM_SIZE) + "px;";
}
function getTooltipContent(label, metaData, arrowType, enableSort, typeText, valueText, indexRange) {
    var title = "<h4 style=\"font-size:14px;color:#333;padding-bottom:10px\">" + label + "</h4>";
    var arrowUpBackgroundStyle = "background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiI+PHBhdGggZmlsbD0iIzg4OCIgZD0iTTEyIDdMOCAzIDQgN2gzdjZoMlY3eiIvPjwvc3ZnPg==);";
    var arrowDownBackgroundStyle = "background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiI+PHBhdGggZmlsbD0iIzg4OCIgZD0iTTkgOVYzSDd2Nkg0bDQgNCA0LTR6Ii8+PC9zdmc+);";
    var arrowStyle = arrowType === "down" ? arrowDownBackgroundStyle : arrowUpBackgroundStyle;
    var typeDescription = typeText || "series";
    var valueDescription = valueText || "value";
    var tooltipHead = enableSort
        ? "<h4 style=\"margin-bottom:10px;font-size:14px;color:#888888;padding-bottom:5px;border-bottom: 1px solid #ECECEC;\"><span>" + typeDescription + "</span><span style=\"float:right;\">" + valueDescription + "<i style=\"cursor: pointer;width: 16px;height: 16px;display: inline-block;vertical-align: middle;background-repeat: no-repeat;background-position: inherit;font-size: 0;" + arrowStyle + "\"></i></span></h4>"
        : "";
    var seriesText = "";
    var isVirtualList = indexRange &&
        typeof indexRange.start !== "undefined" &&
        typeof indexRange.end !== "undefined";
    var tooltipHeadHeight = !enableSort ? 46 : 83;
    for (var i = 0; i < metaData.length; i++) {
        if (isVirtualList && (i < indexRange.start || i > indexRange.end)) {
            // eslint-disable-next-line no-continue
            continue;
        }
        var virtualizedStyle = isVirtualList
            ? getItemStyle(i, tooltipHeadHeight)
            : "";
        var hasLabel = !!metaData[i].label;
        seriesText += "\n    <p style=\"height:20px;line-height:20px;display:table-row;" + virtualizedStyle + "\">\n      <span style=\"display:table-cell;line-height:20px;vertical-align:middle;padding-right:10px;\">\n        <i style=\"display:inline-block;height:4px;width:16px;background:" + metaData[i].color + ";\"></i>\n      </span>\n      <span style=\"display:table-cell;font-size:14px;color:#333;\">" + (hasLabel ? metaData[i].label : "") + "</span>\n      <span style=\"display:table-cell;font-weight:600;color:#333;font-size:14px;padding-left:15px;text-align:right;\">" + metaData[i].valueText + "\n      " + (metaData[i].percentage ? "(" + metaData[i].percentage + "%)" : "") + "</span>\n    </p>";
    }
    return "\n  " + title + "\n  " + tooltipHead + "\n  <div style=\"display:table;\">\n    " + seriesText + "\n  </div>\n  ";
}
exports.getTooltipContent = getTooltipContent;
//# sourceMappingURL=tooltip.js.map